import { Separator, Text } from "../../../components";
import { BuildingsIcon, CaretDownIcon, CaretUpIcon } from "../../../components/icons";
import React from "react";

import {
  AttendeeCaretIconStyle,
  AttendeeHeaderStyle,
  AttendeeInfoBodyStyle,
  AttendeeLeftStyle,
  AttendeeStyle,
} from "../styles";
import { AttendeeInfo } from "@repo-sapiens/data-access-models";

type Props = {
  companies: AttendeeInfo['company_info'][];
  defaultExpanded?: boolean;
};
export const AttendeeCompanyCard: React.FC<Props> = ({
  defaultExpanded,
  companies,
}) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);
  const onExpand = () => {
    setExpanded(!expanded);
  };
  return (
    <div className={AttendeeStyle(expanded || false)}>
      <div className={AttendeeHeaderStyle} onClick={onExpand}>
        <div className={AttendeeLeftStyle}>
          <BuildingsIcon
            style={{ width: "24px", height: "24px" }}
            fill="highlight/1"
          />
          <Separator.Vertical spacing={1} />
          <div>
            <Text.BodySM color="primary">Company info</Text.BodySM>
          </div>
        </div>
        {expanded ? (
          <CaretUpIcon fill="highlight/1" style={AttendeeCaretIconStyle} />
        ) : (
          <CaretDownIcon fill="highlight/1" style={AttendeeCaretIconStyle} />
        )}
      </div>
      <div className={AttendeeInfoBodyStyle}>
        {companies.map((company, idx) => (
          <React.Fragment key={idx}>
            <Separator.Horizontal spacing={5} />
            <Text.BodySM color="highlight/1">{company?.name || "/"}</Text.BodySM>

            <Separator.Horizontal spacing={2} />
            <AttendeeItemLabel
              label="Location"
              value={company?.location || "/"}
            />
            <Separator.Horizontal spacing={2} />
            <AttendeeItemLabel
              label="Industry"
              value={company?.industries || "/"}
            />

            <Separator.Horizontal spacing={2} />
            <AttendeeItemLabel
              label="Product & Services"
              value={company?.product_services || "/"}
            />

            <Separator.Horizontal spacing={2} />
            <AttendeeItemLabel
              label="Year founded"
              value={company?.founded_year || "/"}
            />

            <Separator.Horizontal spacing={2} />
            <AttendeeItemLabel
              label="Funding"
              value={company?.total_funding || "/"}
            />
            <Separator.Horizontal spacing={2} />

            <AttendeeItemLabel
              label="Annual revenue"
              value={company?.annual_revenue || "/"}
            />

            <Separator.Horizontal spacing={2} />
            <AttendeeItemLabel
              label="Description"
              value={company?.description || "/"}
            />

            <Separator.Horizontal spacing={2} />
            <AttendeeItemLabel label="Website" value={company?.website || ""} link />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

type AttendeeItemLabelProps = {
  label: string;
  value: string;
  link?: boolean;
};
function AttendeeItemLabel({ label, value, link }: AttendeeItemLabelProps) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Text.Body2XS color="darkGrey">{label}</Text.Body2XS>
      {(!link || !value) && (
        <Text.BodySM color="primary">{value || "/"}</Text.BodySM>
      )}
      {link && value && (
        <Text.Link href={value} target="_blank" size="body-sm">
          {value}
        </Text.Link>
      )}
    </div>
  );
}
